// For elements sized by a fixed dimension (e.g. object-fit: cover with a
// fixed height); use GenerateSrcSet's width descriptors for fluid-width images.
export const generateDensitySrcSet = (
  src: string,
  loader: (args: { src: string; height: number }) => string,
  baseHeight: number,
  densities: number[] = [1, 2],
) =>
  densities
    .map(density => `${loader({ src, height: baseHeight * density })} ${density}x`)
    .join(', ');
